import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';

const Callout = (props) => {
  const { title, subtitle, content, image, className } = props;
  return (
    <StyledSection className={className}>
      <Subtitle>{subtitle}</Subtitle>
      <Title>{title}</Title>
      <Content>{content}</Content>
      <GatsbyImage
        image={image.childImageSharp.gatsbyImageData}
        alt="A screenshot of Commerce7 platform."
      />
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  max-width: 1700px;
  margin: 0 auto 225px;
  background: var(--gray-light);
  text-align: center;
  border-radius: 15px;
  padding: 125px 50px 0px;
  .gatsby-image-wrapper {
    max-width: 927px;
    margin: auto;
  }
`;

const Subtitle = styled.h3`
  color: var(--gray-dark);
  font-size: var(--font-size-lg);
  letter-spacing: var(--letter-spacing-base);
  margin-bottom: 10px;
`;

const Title = styled.h2`
  font-size: var(--heading-size-base);
  color: var(--blue-dark);
  font-weight: var(--font-weight-bold);
  margin-bottom: 30px;
  line-height: var(--line-height-base);
`;

const Content = styled.p`
  max-width: 1100px;
  margin: 0 auto 60px;
`;

export default Callout;
